import { MainWindow } from '@mobile-mapping/ui';
import { JSX } from 'solid-js';
import { useUrlSync } from '../hooks/useUrlSync';
import { getConfig } from '../../config/config';

const HomePage = (): JSX.Element => {
  const { urlSyncComplete } = useUrlSync();

  return (
    <MainWindow
      web3DPath={import.meta.env.VITE_WEB3D_PATH}
      helpUrl={getConfig().helpUrl}
      profileUrl={getConfig().profileUrl}
      urlSyncComplete={urlSyncComplete}
    />
  );
};

export default HomePage;
